import { StyledButton } from 'src/app/components/Pages/GetStarted/styles';

import { Divider, FlexColumn, GreenLink, SectionItem, SectionTitle } from '../../styles';

interface DefaultRxNotFoundProps {
  onChatClick: () => void;
  onContinue: () => void;
}

const DefaultRxNotFound = ({ onChatClick, onContinue }: DefaultRxNotFoundProps) => {
  // We are showing processing even when we cant find meds or escripts, this is subject to change
  return (
    <>
      <Divider />
      <SectionTitle>Your Medications</SectionTitle>
      <FlexColumn>
        <SectionItem hasMarginBottom={true}>
          We’re processing your prescriptions and will text you to schedule your free delivery
        </SectionItem>
        <SectionItem>
          Questions? <GreenLink onClick={onChatClick}>Chat with a pharmacist</GreenLink>
        </SectionItem>
      </FlexColumn>
      <Divider />
      <StyledButton onClick={onContinue} type="submit" size="medium" style={'capsuleBlue50'}>
        Continue
      </StyledButton>
    </>
  );
};

interface RxNotFoundProps {
  onChatClick: () => void;
  onContinue: () => void;
}

export const RxNotFound = ({ onChatClick, onContinue }: RxNotFoundProps) => {
  return <DefaultRxNotFound onChatClick={onChatClick} onContinue={onContinue} />;
};
